import { METHOD } from '../method'

export const API_MINI_BANNER = {
    DETAIL: {
        api: '/v1/dashboard-admin/main-page/home-page/mini-banner',
        method: METHOD.GET,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/main-page/home-page/mini-banner',
        method: METHOD.PUT,
    },
    URL_MINI_BANNER: {
        api: '/v1/dashboard-admin/main-page/home-page/mini-banner/storage-url/attachment',
        method: METHOD.POST,
    },
}
